import script from "./NotifyStaffCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./NotifyStaffCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./NotifyStaffCheckbox.vue?vue&type=style&index=0&id=0db65fad&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0db65fad"]])

export default __exports__